(function(){
// ---- Blackheart geometry (Ti) : size, stack, reach, hta, standover, stock stem
const BH = {
  road:    {name:"Road Ti", blurb:"Fast road", sizes:[
    [46,515,372,71.5,675,80],[49,526,374,72,700,90],[52,538,376,72.5,725,90],[54,552,382,73,750,100],
    [56,567,387,73,775,110],[58,583,392,73.5,800,110],[60,596,403,73.5,825,110],[62,617,411,74,850,120],[64,636,425,74,875,120]]},
  roadplus:{name:"Road Plus Ti", blurb:"Fast fun on any surface", sizes:[
    [46,530,378,71,675,80],[49,541,380,71.5,700,90],[52,550,383,71.5,725,100],[54,567,387,72,750,100],
    [56,581,394,72,775,100],[58,597,399,72.5,800,100],[60,610,409,72.5,825,100],[62,629,419,72.5,850,100],[64,648,427,72.5,875,100]]},
  allroad: {name:"All Road Ti", blurb:"Do-it-all", sizes:[
    [46,533,377,71.5,689,80],[49,542,379,71.5,711,90],[52,551,381,71.5,737,90],[54,567,386,72,762,100],
    [56,580,392,72,787,100],[58,596,397,72.5,813,100],[60,610,403,72.5,838,100],[62,624,413,72.5,864,100],[64,638,424,72.5,889,100]]},
  gravel:  {name:"Gravel Ti", blurb:"The bumpy stuff", sizes:[
    [46,531,388,71,725,80],[49,540,390,71,740,80],[52,550,393,71,755,80],[54,564,398,71.25,770,90],
    [56,579,404,71.25,785,90],[58,594,410,71.5,800,100],[60,608,420,71.5,815,100],[62,627,429,71.5,830,100],[64,645,444,71.5,845,100]]}
};
// Full Blackheart charts (from BlackHeart Geometry.xlsx, Oct 2026): size, seat tube, top tube, reach, stack, head tube, fork A2C, rake, HT angle, ST angle, front center, rear center, wheelbase, BB drop, standover
const BHGEO = {
  road:[[46,440,505,372,515,110,371,43,71.5,75.5,570,410,969,74,675],[49,460,515,374,526,120,371,43,72,75,571,410,969,74,700],[52,480,525,376,538,130,371,43,72.5,74.5,572,410,970,74,725],
    [54,500,540,382,552,145,371,43,73,74,578,410,977,73,750],[56,515,555,387,567,160,371,43,73,73.5,588,410,987,73,775],[58,530,565,392,583,175,371,43,73.5,73.5,593,410,992,73,800],
    [60,545,580,403,596,190,371,43,73.5,73.5,608,410,1007,72,825],[62,565,600,411,617,210,371,43,74,73,617,410,1016,72,850],[64,585,620,425,636,230,371,43,74,73,636,410,1036,72,875]],
  roadplus:[[46,440,510,378,530,120,380,51,71,75.5,589,422,1000,73,675],[49,460,520,380,541,130,380,51,71.5,75,590,422,1001,73,700],[52,480,530,383,550,140,380,51,71.5,74.5,596,422,1007,72,725],
    [54,500,545,387,567,155,380,47,72,74,597,422,1009,72,750],[56,515,555,394,581,170,380,47,72,73.5,608,422,1020,71,775],[58,530,565,399,597,185,380,47,72.5,73.5,613,422,1025,71,800],
    [60,545,585,409,610,200,380,47,72.5,73.5,628,422,1040,70,825],[62,565,600,419,629,220,380,47,72.5,73,643,422,1055,70,850],[64,585,620,427,648,240,380,47,72.5,73,657,422,1070,70,875]],
  gravel:[[46,440,535,388,531,110,395,55,71,74.5,608,427,1024,74,725],[49,460,540,390,540,120,395,55,71,74.5,613,427,1029,74,740],[52,480,545,393,550,130,395,55,71,74.5,619,427,1035,74,755],
    [54,500,560,398,564,145,395,55,71.25,74,627,427,1044,73,770],[56,515,570,404,579,160,395,53,71.25,74,636,427,1052,73,785],[58,530,580,410,594,175,395,53,71.5,74,644,427,1061,73,800],
    [60,545,600,420,608,190,395,53,71.5,73.5,659,427,1076,72,815],[62,565,615,429,627,210,395,53,71.5,73.5,675,427,1092,72,830],[64,585,635,444,645,230,395,53,71.5,73.5,695,427,1113,72,845]],
  allroad:[[46,460,535,377,533,100,400,47,71.5,73.5,585,422,996,73,689],[49,490,545,379,542,110,400,47,71.5,73,590,422,1001,73,711],[52,520,555,381,551,120,400,47,71.5,72.5,595,422,1007,72,737],
    [54,540,565,386,567,135,400,47,72,72.5,601,422,1012,72,762],[56,560,575,392,580,150,400,47,72,72.5,611,422,1023,71,787],[58,580,585,397,596,165,400,47,72.5,72.5,616,422,1028,71,813],
    [60,600,595,403,610,180,400,47,72.5,72.5,626,423,1039,70,838],[62,620,610,413,624,195,400,47,72.5,72.5,641,422,1055,70,864],[64,640,625,424,638,210,400,47,72.5,72.5,656,422,1071,70,889]]
};
const FG_KEYS = ["seatTube","topTube","reach","stack","headTube","forkA2C","forkRake","htAngle","stAngle","frontCenter","rearCenter","wheelbase","bbDrop","standover"];
const FG_LABELS = {seatTube:"Seat Tube",topTube:"Top Tube",reach:"Reach",stack:"Stack",headTube:"Head Tube",forkA2C:"Fork Length (A2C)",forkRake:"Fork Rake",htAngle:"Head Tube Angle",stAngle:"Seat Tube Angle",frontCenter:"Front Center",rearCenter:"Rear Center",wheelbase:"Wheelbase",bbDrop:"BB Drop",standover:"Standover"};
function bhGeo(mdl,size){ const row=BHGEO[mdl].find(r=>String(r[0])===String(size)); if(!row) return {}; const o={}; FG_KEYS.forEach((k,i)=>o[k]=row[i+1]); return o; }
// Column heading for the rider's bike: its model name, or "Your bike" when numbers were typed in
function bikeName(cur){ const l = String(cur.label||"").replace(/\s*\(edited\)$/,"").trim(); return l && l!=="My bike" ? l : "Your bike"; }
// Numbers in the rider's column of the Full Geometry Chart: typed in (Enter Numbers), or found by the AI search
// for bikes older than the catalogue, with any gaps left as boxes to fill in
const MAN = {}, FREE = {};
let freeVersion = 0;
const geoStore = () => mode==="manual" ? MAN : FREE;
const editable = () => mode==="manual" || isFree();
const MAN_RANGE = {stack:[450,750], reach:[320,480]};
function manVal(k){ const v = geoStore()[k], r = MAN_RANGE[k]; return typeof v==="number" && isFinite(v) && (!r || (v>=r[0] && v<=r[1])) ? v : null; }
// Work out frame stack and reach from the rest of a chart when it doesn't list them
// Work out frame stack and reach from a partial chart. Every input must be on the chart (no assumed fork offset):
// stack needs fork A2C, fork offset, head tube, head angle and BB drop; reach needs those plus front center,
// wheelbase with chainstay (rear center), or top tube with seat angle
function fillStackReach(g){
  const has = k => typeof g[k]==="number" && isFinite(g[k]);
  const out = [];
  if(!has("htAngle") || !has("forkRake")) return out;
  const hta = rad(g.htAngle), rake = g.forkRake;
  const axis = has("forkA2C") && has("headTube") ? Math.sqrt(Math.max(g.forkA2C*g.forkA2C - rake*rake, 0)) + g.headTube : null;
  if(!has("stack") && axis && has("bbDrop")){ g.stack = Math.round(g.bbDrop + axis*Math.sin(hta) - rake*Math.cos(hta)); out.push("stack"); }
  if(!has("reach")){
    // Horizontal distance from the BB to the front axle
    const fcX = !has("bbDrop") ? null
      : has("frontCenter") ? Math.sqrt(Math.max(g.frontCenter*g.frontCenter - g.bbDrop*g.bbDrop,0))
      : has("wheelbase") && has("rearCenter") ? g.wheelbase - Math.sqrt(Math.max(g.rearCenter*g.rearCenter - g.bbDrop*g.bbDrop,0))
      : null;
    if(axis && fcX){ g.reach = Math.round(fcX - rake*Math.sin(hta) - axis*Math.cos(hta)); out.push("reach"); }
    else if(has("topTube") && has("stAngle") && has("stack")){ g.reach = Math.round(g.topTube - g.stack/Math.tan(rad(g.stAngle))); out.push("reach"); }
  }
  return out;
}
function renderFullGeo(cur,b,t){
  const manual = editable(), store = geoStore();
  const yours = manual ? Object.assign({}, store) : Object.assign({}, cur.geo||{}, {stack:cur.stack, reach:cur.reach, htAngle:cur.hta, standover:cur.so});
  // No match yet (b.blank): the BlackHeart column stays empty under a generic header
  const bh = b.blank ? {} : bhGeo(model,b.size);
  $("fgYou").textContent = bikeName(cur);
  $("fgBH").textContent = b.blank ? "Your BlackHeart" : `BlackHeart ${BH[model].name} ${b.size}`;
  const body = $("fgBody"), kind = manual ? (mode==="manual" ? "input:man" : "input:free:"+freeVersion) : "text";
  // Rebuild rows only when switching modes, so typing in a box keeps its focus
  if(body.dataset.kind!==kind){
    body.innerHTML = FG_KEYS.map(k=>{
      const ang = k.endsWith("Angle");
      const cell = manual ? `<input type="number" class="byb-fgin" id="fgIn_${k}" inputmode="decimal" step="${ang?"0.1":"1"}" aria-label="Your bike ${FG_LABELS[k]}${ang?" (degrees)":" (mm)"}" value="${store[k]??""}">` : "";
      return `<tr><td>${FG_LABELS[k]}</td><td class="byb-n" id="fgA_${k}">${cell}</td><td class="byb-n" id="fgB_${k}"></td></tr>`;
    }).join("");
    body.dataset.kind = kind;
    if(manual) FG_KEYS.forEach(k=>$("fgIn_"+k).addEventListener("input",e=>{
      const v = parseFloat(e.target.value), st = geoStore(); if(isNaN(v)) delete st[k]; else st[k]=v;
      markDirty(); if(mode==="pick") syncPicker(); render();   // refresh the search note as gaps get filled
    }));
  }
  FG_KEYS.forEach(k=>{
    const ang = k.endsWith("Angle"), u = ang?"°":"";
    const show = v => (typeof v==="number" && isFinite(v)) ? (ang ? (+v).toFixed(2).replace(/\.?0+$/,"") : Math.round(v)) + u : "—";
    const a=yours[k], c=bh[k];
    if(!manual) $("fgA_"+k).textContent = show(a);
    $("fgB_"+k).textContent = show(c);
  });
  // Setup rows: the rider's stem and spacers from the dropdowns, the Blackheart's from the match; +/- on the effective numbers
  if(!t || !b.p){ $("fgFoot").innerHTML = ""; return; }
  const row = (label,mine,bhv,diff) => `<tr><td>${label}</td><td class="byb-n">${Math.round(mine)}</td><td class="byb-n">${Math.round(bhv)}${diff ? ` <span class="${diffCls(bhv-mine)}">${fmt(bhv-mine)}</span>` : ""}</td></tr>`;
  $("fgFoot").innerHTML = row("Stem Length", num("stem",90), b.stem) + row("Stem Spacers", num("spc",20), b.spc)
    + row("Effective Reach <span class='byb-formula'>(Frame Reach + Stem Length)</span>", t.x, b.p.x, true) + row("Effective Stack <span class='byb-formula'>(Fork Length A2C + Head Tube + Stem Spacers)</span>", t.y, b.p.y, true);
}
// ---- Other brands : size, stack, reach, standover, stock stem ; hta approx per model
const OTHER = [
  {id:"crosscheck", name:"Surly Cross-Check (2016–2023)", hta:72, ang:-6, angSpec:false, sizes:[["42",528,379,748,70],["46",528,381,767,80],["50",528,389,784,80],["52",528,390,794,100],["54",538,395,809,100],["56",557,394,827,100],["58",576,398,846,120],["60",594,407,863,120],["62",613,411,882,120],["64",631,425,902,120]]},
  // ang = stock stem angle; angSpec = true when taken from the maker's build spec, false when it's the brand's usual stem
  {id:"crux",  name:"Specialized Crux (2024)", hta:71.75, ang:-6, angSpec:true, sizes:[["49",530,375,749,70],["52",547,382,772,80],["54",560,388,794,90],["56",578,397,816,100],["58",598,405,841,110],["61",621,415,866,110]]},
  {id:"aethos",name:"Specialized Aethos 2 (2026)", hta:72.5, ang:-6, angSpec:true, sizes:[["49",522,373,719,80],["52",538,377,737,90],["54",559,384,759,100],["56",580,391,779,100],["58",606,398,805,110],["61",627,404,834,110]]},
  {id:"tarmac",name:"Specialized Tarmac SL8 / SL9", hta:73, ang:-6, angSpec:false, sizes:[["44",501,366,722,75],["49",514,375,734,75],["52",527,380,745,90],["54",544,384,767,100],["56",565,395,785,100],["58",591,402,807,110],["61",612,408,833,110]]},
  {id:"checkpoint",name:"Trek Checkpoint SLR (2024)", hta:71, ang:-7, angSpec:true, sizes:[["49",538,393,735,70],["52",553,399,765,80],["54",571,403,789,80],["56",592,407,809,90],["58",609,411,829,90],["61",639,417,859,100]]},
  {id:"domane",name:"Trek Domane SL Gen 3", hta:72.5, ang:-7, angSpec:true, sizes:[["47",527,364,686,70],["50",546,368,716,80],["52",561,371,735,90],["54",575,374,754,90],["56",591,377,776,100],["58",611,380,796,100],["60",632,383,817,110],["62",656,386,835,110]]},
  {id:"grizl", name:"Canyon Grizl CF SL (2024)", hta:71.5, ang:-6, angSpec:true, sizes:[["2XS",522,377,737,70],["XS",537,382,761,70],["S",556,397,789,70],["M",579,402,816,80],["L",605,409,845,90],["XL",626,427,870,90],["2XL",644,436,892,100]]},
  {id:"endurace",name:"Canyon Endurace CF SLX (2024)", hta:72.5, ang:-6, angSpec:false, sizes:[["3XS",510,350,708,70],["2XS",529,354,734,80],["XS",548,370,763,80],["S",568,375,788,90],["M",590,378,815,100],["L",611,387,840,110],["XL",637,405,867,110],["2XL",656,415,891,120]]},
  {id:"tcr",   name:"Giant TCR Advanced Pro (2024)", hta:73, ang:-8, angSpec:false, sizes:[["M",528,383,722,90],["ML",545,388,743,100],["L",562,393,771,110],["XL",581,402,798,110]]}
];
 
const $ = id => document.getElementById(id);
const CONSULT_URL = ($("byb") && $("byb").dataset.consult) || "/pages/perfect-fit";
["consultBtn","consultTop"].forEach(id=>{ if($(id)) $(id).href = CONSULT_URL; });
const CALENDLY_URL = (($("byb") && $("byb").dataset.calendly) || "").trim();
const rad = d => d*Math.PI/180;
const CAP = 15; // top cap + half stem height, mm along steerer (same for both bikes)
 
function bars(stack,reach,hta,spacer,stem,ang){
  const along = spacer + CAP;
  const theta = rad(90 - hta + ang);
  return {
    x: reach - along*Math.cos(rad(hta)) + stem*Math.cos(theta),
    y: stack + along*Math.sin(rad(hta)) + stem*Math.sin(theta),
    hx: reach, hy: stack,
    sx: reach - along*Math.cos(rad(hta)), sy: stack + along*Math.sin(rad(hta))
  };
}
// ENVE Hi-Rise: a +12° stem whose bar clamp sits 43.5–49mm higher than a −6° stem of the same length (80mm → 130mm)
const hiRiseLift = L => 43.5 + (Math.min(Math.max(L,80),130)-80) * (49-43.5)/50;
function stemBars(stack,reach,hta,spacer,L,stem){
  if(!stem.hiRise) return bars(stack,reach,hta,spacer,L,stem.ang);
  const p = bars(stack,reach,hta,spacer,L,12);
  p.y = bars(stack,reach,hta,spacer,L,-6).y + hiRiseLift(L);
  return p;
}
// Rider's bars with the stem picked in the dropdown
function riderBars(stack,reach,hta,spacer,L){
  return $("ang").value==="enve" ? stemBars(stack,reach,hta,spacer,L,{hiRise:true}) : bars(stack,reach,hta,spacer,L,num("ang",-6));
}
// Handlebar systems for the Blackheart and the stems each one uses (max 30mm of spacers with any of them).
// A fallback stem is only used when the main one can't get close: Hi-Rise when the bars sit too low, Zipp SL when the reach is too short.
const HANDLEBARS = {
  blackheart:{label:"BlackHeart", stems:[{name:"BlackHeart", ang:-10, min:80, max:120}]},
  enve:{label:"ENVE", stems:[{name:"ENVE", ang:-7, min:80, max:130}, {name:"ENVE Hi-Rise", hiRise:true, min:80, max:130, when:b=>b.dy < -5}]},
  zipp:{label:"Zipp", stems:[{name:"Cane Creek HCR", ang:-6, min:70, max:120}, {name:"Zipp SL", ang:-6, min:130, max:150, when:b=>b.dx < -5}]}
};
 
let mode = "pick", model = "road", handlebar = "blackheart", userTouchedModel = false, dirty = false;
 
let lastPick = null;
// Full charts for the built-in bikes (Bike Insights; null = not published). Same column order as BHGEO.
const OTHERGEO = {
  crosscheck:[["42",420,505,378.7,528,91,400,44,72,75,578.8,420,989.8,66,747.9],["46",460,515,380.8,528,91,400,44,72,74.5,580.9,420,991.9,66,766.7],["50",500,535.1,389.1,528,91,400,44,72,74,589.1,425,1005.2,66,784.4],["52",520,545.1,389.7,528,91,400,44,72,73.5,589.8,425,1005.9,66,794.4],["54",540,559.9,394.8,538.4,102,400,44,72,73,598.1,425,1014.3,66,809],["56",560,569.9,394.3,556.5,121,400,44,72,72.5,603.5,425,1019.7,66,826.7],["58",580,579.8,398.3,575.7,141,400,44,72,72.5,613.6,425,1029.9,66,845.9],["60",600,599.8,407.3,593.6,160,400,44,72,72,628.3,425,1044.7,66,863.4],["62",620,609.9,411,612.7,180,400,44,72,72,638.3,425,1054.7,66,882.2],["64",665,630,424.5,630.9,200,400,44,72,72,658.1,425,1074.6,66,901.8]],
  crux:[["49",466,512,375,530,100,401,50,70.5,75.5,594,425,1008,74,749],["52",496,539,382,547,115,401,50.1,71.25,74,600,425,1014,74,772],["54",521,549,388,560,130,401,50.1,71.5,74,608,425,1023,72,794],["56",546,568,397,578,147,401,50.2,72,73.5,618,425,1033,72,816],["58",576,582,405,598,167,401,50.3,72.25,73.5,630,425,1045,72,841],["61",606,599,415,621,190,401,49.6,72.5,73.5,644,425,1059,72,866]],
  aethos:[["49",450,508,373,522,114,372,50,71.4,75.5,581,410,978,76.5,719],["52",470,526,377,538,128,372,50,72.1,74.5,584,410,981,76.5,737],["54",490,544,384,559,150,372,50,72.5,74,594,410,992,75,759],["56",510,557,391,580,169,372,47,73,74,599,410,998,75,779],["58",535,572,398,606,198,372,47,73,74,614,410,1013,73.5,805],["61",570,584,404,627,218,372,47,73.5,74,621,410,1020,73.5,834]],
  tarmac:[["44",433,496,366,501,99,370,47,70.5,75.5,572,410,970,74,723],["49",445,509,375,514,109,370,47,71.75,75.5,574,410,973,74,735],["52",456,531,380,527,120,370,47,72.5,74,577,410,975,74,746],["54",473,541,384,544,137,370,44,73,74,579,410,978,72,768],["56",494,563,395,565,157,370,44,73.5,73.5,592,410,991,72,786],["58",515,577,402,591,184,370,44,73.5,73.5,606,410,1006,72,808],["61",545,595,408,612,204,370,44,74,73,613,410,1013,72,834]],
  checkpoint:[["49",490,541,393,538,90,null,45,71.2,74.1,602.1,435,1025,78,735],["52",520,555,399,553,105,null,45,71.6,73.7,610.1,435,1033,78,765],["54",540,570,403,571,125,null,45,71.8,73.2,617.4,435,1041,76,789],["56",560,584,407,592,145,null,45,72.2,72.8,624.3,435,1048,76,809],["58",580,597,411,609,165,null,45,72.3,72.5,633.7,435,1058,74,829],["61",610,617,417,639,195,null,45,72.6,72.1,645.6,435,1070,74,859]],
  domane:[["47",420,509,364,527,110,null,53,71,74.6,579.2,420,986,80,686],["50",450,519,368,546,130,null,53,71.1,74.6,589.2,420,996,80,716],["52",475,530,371,561,145,null,53,71.3,74.2,596.1,420,1003,80,735],["54",500,542,374,575,160,null,53,71.3,73.7,603,420,1010,80,754],["56",525,554,377,591,175,null,48,71.9,73.3,600.4,420,1008,78,776],["58",548,567,380,611,195,null,48,72,73,609.2,425,1022,78,796],["60",567,579,383,632,220,null,48,72.1,72.8,618.2,425,1032,75,817],["62",586,593,386,656,245,null,48,72.1,72.5,628.2,425,1042,75,835]],
  grizl:[["2XS",432,522,377,522,121,null,39.3,70,73.5,590.1,420,1007,60,737],["XS",462,531,382,537,133,null,38.5,71,73.5,590.1,420,1007,60,761],["S",492,552,397,556,118,null,36.3,71,73.5,605.7,435,1036,75,789],["M",522,564,402,579,138,null,36.8,72.25,73.5,606.7,435,1037,75,816],["L",552,578,409,605,164,null,37.1,72.5,73.5,619.6,435,1050,75,845],["XL",582,602,427,626,185,null,37.2,72.75,73.5,641.4,435,1072,75,870],["2XL",612,617,436,644,204,null,36.6,72.75,73.5,655.3,435,1086,75,892]],
  endurace:[["3XS",402,509,350,510,123,null,44.6,70.3,73.5,561.7,405,959,60,708],["2XS",432,519,354,529,138,null,44.1,71.5,73.5,560.7,405,958,60,734],["XS",462,540,370,548,129,null,44.4,70.8,73.5,587,415,991,73,763],["S",492,551,375,568,146,null,44.4,71.8,73.5,589,415,993,73,788],["M",522,561,378,590,165,null,43.9,72.75,73.5,589,415,993,73,815],["L",552,576,387,611,186,null,44,73,73.5,601.9,415,1006,73,840],["XL",582,602,405,637,212,null,44.3,73.3,73.5,624.8,415,1029,73,867],["2XL",612,617,415,656,232,null,43.6,73.3,73.5,639.7,415,1044,73,891]],
  tcr:[["M",445,535,383,528,130,null,45,72.3,74,582.2,405,977,69.5,722],["ML",470,550,388,545,145,null,45,73.5,73.5,585.2,405,980,69.5,743],["L",500,565,393,562,165,null,45,73,73,595.4,405,991,67,771],["XL",530,580,402,581,185,null,45,73,73,610.3,405,1006,67,798]]
};
function otherGeo(id,size){ const row=(OTHERGEO[id]||[]).find(r=>r[0]===size); if(!row) return null; const o={}; FG_KEYS.forEach((k,i)=>o[k]=row[i+1]); return o; }
// Model years each built-in chart covers [first, last]; null = still current
const BUILTIN_YEARS = {crosscheck:[2016,2023], crux:[2022,null], aethos:[2026,null], tarmac:[2024,null], checkpoint:[2023,null], domane:[2020,2022], grizl:[2021,null], endurace:[2020,2024], tcr:[2021,2024]};
function builtInFor(name, yr){
  const id = name && INLIST[name];
  if(id){
    const r = BUILTIN_YEARS[id];
    if(!(r && (yr < r[0] || (r[1]!==null && yr > r[1])))) return OTHER.find(o=>o.id===id) || null;
  }
  const vs = name && DBKEY[name]; if(!vs) return null;
  // the frame version for that year; a gap year uses the closest version (within 2 years)
  let best=null, gap=99;
  for(const v of vs){ const g = yr<v[0] ? v[0]-yr : (yr>v[1] ? yr-v[1] : 0); if(g<gap){gap=g;best=v;} }
  if(!best || gap>2) return null;
  const [from,to,note,rows] = best;
  return {id:"db:"+name+":"+from, name:`${name} (${from===to?from:from+"–"+(to>=CURRENT_MY?"present":to)})`, note, hta:72, ang:-6, angSpec:false,
          rows, sizes: rows.map(r=>[r[0], r[4], r[3], r[14], r[15]])};
}
function rowGeo(row){ const o={}; FG_KEYS.forEach((k,i)=>o[k]=row[i+1]); return o; }
function builtInPick(){
  if(isFree()) return null;
  const name = pickedName(), b = name && builtInFor(name, +$("pkYear").value);
  if(!b) return null;
  const s = b.sizes.find(z=>z[0]===$("pkSize").value);
  const g = s ? (b.rows ? rowGeo(b.rows.find(r=>r[0]===s[0])) : otherGeo(b.id, s[0])) : null;
  return s ? {label:`${$("pkYear").value} ${name} ${s[0]}`, geo:g, stack:s[1], reach:s[2], hta:(g&&g.htAngle)||b.hta, so:s[3], stock:s[4], ang:b.ang, angSpec:b.angSpec} : null;
}
function current(){
  if(mode==="pick" && !isFree()){
    const p = builtInPick();
    if(p) lastPick = p;
    return lastPick || {label:"", stack:null, reach:null, hta:null, so:null, none:true};   // nothing chosen yet
  }
  const so = manVal("standover"), hta = manVal("htAngle");
  const label = [mode==="manual" ? freeTxt("pkYearTxt") : $("pkYear").value, freeTxt("pkBrandTxt"), freeTxt("pkModelTxt"), freeTxt("pkSizeTxt")].filter(Boolean).join(" ");
  return {label:label||"My bike", geo:geoStore(), stack:manVal("stack"), reach:manVal("reach"), hta: hta>=60 && hta<=80 ? hta : 72, so};
}
function num(id,def){const v=parseFloat($(id).value);return isNaN(v)?def:v;}
 
// Bars within this many mm (straight-line) of today's position count as a fit, so neither +/- on the recommendation turns red
const FIT_TOL = 5;
const inTol = r => r.off <= FIT_TOL;
// Frame sizes allowed for a rider's height (inches). Each range includes its low end but not its high end
// (the top row includes 82"), and the ranges overlap, so a height can allow sizes from more than one row.
const HEIGHT_SIZES = [[60,66,[46,49]],[63,68,[49,52]],[66,70,[52,54]],[68,72,[54,56]],[70,74,[56,58]],[72,76,[58,60]],[74,79,[60,62]],[76,82,[62,64]]];
const sizesForHeight = h => h ? new Set(HEIGHT_SIZES.filter(([lo,hi])=>h>=lo && (h<hi || hi===82)).flatMap(r=>r[2])) : null;
function solve(cur, target, mdl, height){
  const [main, ...fallbacks] = HANDLEBARS[handlebar].stems;
  // Setup for one size: the fewest spacers that fit, then the closest bars; if nothing fits, the closest bars
  const better = (c,o) => {
    if(!o) return true;
    if(inTol(c) !== inTol(o)) return inTol(c);
    if(inTol(c) && c.spc !== o.spc) return c.spc < o.spc;
    return c.off < o.off - 1e-6;
  };
  let results = [];
  for(const s of BH[mdl].sizes){
    const [size,stack,reach,hta,so] = s;
    const fit = stem => {
      let best=null;
      for(let L=stem.min; L<=stem.max; L+=10){
        for(let spc=0; spc<=30; spc+=5){              // max 30mm of spacers
          const p = stemBars(stack,reach,hta,spc,L,stem);
          const dx = p.x - target.x, dy = p.y - target.y;
          const c = {size,stack,reach,hta,so,stem:L,stemName:stem.name,spc,dx,dy,off:Math.hypot(dx,dy),p};
          if(better(c,best)) best = c;
        }
      }
      return best;
    };
    let best = fit(main);
    // Fallback stems (ENVE Hi-Rise, Zipp SL) only when the regular stem can't get the bars there
    for(const f of fallbacks){ if(f.when(best)){ const alt = fit(f); if(inTol(alt) && !inTol(best) || !inTol(best) && alt.off < best.off - 2) best = alt; } }
    results.push(best);
  }
  // Size: only sizes the height chart allows (when the rider gave a height), even if their bars end up more than FIT_TOL off;
  // then the largest frame that fits, or if none fits, the one that gets the bars closest
  const allowed = sizesForHeight(height), ok = r => !allowed || allowed.has(r.size) ? 1 : 0;
  results.sort((a,b)=>(ok(b)-ok(a)) || (inTol(b)-inTol(a)) || (inTol(a) ? b.size-a.size : a.off-b.off));
  return results;
}
 
// A +/- over 5mm shows in red
const diffCls = d => "byb-effdiff" + (Math.abs(Math.round(d))>5 ? " byb-over" : "");
function fmt(n){const r=Math.round(n);return (r>0?"+":r<0?"−":"±")+Math.abs(r);}
 
function riderBrand(){
  const txt = mode==="manual" || isFree();
  return (txt ? freeTxt("pkBrandTxt") : $("pkBrand").value).slice(0,40);
}
let browse = null;   // {key, size} while the rider is looking at a size other than the recommended one
function render(){
  const cur = current();
  const missing = [["height","height"],["stem","stem length"],["spc","spacers"],["ang","stem angle"]].filter(([id])=>!$(id).value).map(x=>x[1]);
  const need = cur.none || editable() && !(cur.stack && cur.reach) || missing.length>0;
  $("needNums").hidden = !need; $("rResult").hidden = need;
  $("cmpFields").disabled = need;   // the comparison stays greyed out until Your Current Bike is complete
  $("needNums").textContent = cur.none ? "Choose your bike above to see your match."
    : editable() && !(cur.stack && cur.reach) ? "Type your bike's stack and reach in the Full Geometry Chart below to see your match."
    : `Choose your ${missing.length>1 ? missing.slice(0,-1).join(", ")+" and "+missing.at(-1) : missing[0]} above to see your match.`;
  if(need){
    if(!userTouchedModel) model = "road";
    renderModels();
    renderFullGeo(cur, {blank:true});
    return;
  }
  const stem = num("stem",90), spc = num("spc",20), ang = num("ang",-6);
  const t = riderBars(cur.stack,cur.reach,cur.hta,spc,stem);
  cur.spc = spc;
  if(!userTouchedModel) model = "road";
  renderModels();
  const res = solve(cur,t,model,num("height",0));
  // The arrows let the rider look at the next size up or down; it resets when the recommendation changes
  const rec = res[0], sizes = BH[model].sizes.map(z=>z[0]), recKey = model+"|"+rec.size;
  if(browse && browse.key!==recKey) browse = null;
  const b = browse ? res.find(r=>r.size===browse.size) : rec;
  const i = sizes.indexOf(b.size);
  $("rSize").textContent = b.size;
  $("rSizeLbl").innerHTML = b===rec ? "Recommended size" : `Size <span class="byb-formula">(recommended: ${rec.size})</span>`;
  $("sizeUp").disabled = i>=sizes.length-1; $("sizeDown").disabled = i<=0;
  window.__step = d => { const n = sizes[i+d]; if(n===undefined) return; browse = n===rec.size ? null : {key:recKey, size:n}; render(); };
  // Where the bars sit on the recommended Blackheart: horizontal and vertical distance from the BB to the stem's bar clamp
  // with a +/- against the rider's bike as set up today
  const eff = (id,v,mine) => { $(id).innerHTML = `${Math.round(v)} mm <span class="${diffCls(v-mine)}">${fmt(v-mine)} mm</span>`; };
  eff("rEffReach", b.p.x, t.x);
  eff("rEffStack", b.p.y, t.y);
  $("rSetup").innerHTML = `${b.stem}mm ${esc(b.stemName)} stem<br>${b.spc}mm spacers`;
  $("lgYou").textContent = riderBrand() || "Your Bike";
  drawPlot(t,b);
  renderFullGeo(cur,b,t);
  window.__match = {cur,stem,spc,ang,b,model,t};
}
 
function renderModels(){
  const box=$("models");
  box.innerHTML = Object.entries(BH).map(([k,v])=>`<button type="button" data-m="${k}" aria-pressed="${k===model}">${v.name.replace(/ Ti$/,"")}</button>`).join("");
  box.querySelectorAll("button").forEach(btn=>btn.onclick=()=>{model=btn.dataset.m;userTouchedModel=true;render();});
}
 
// Side view of both bikes: the rider's in grey, the Blackheart in orange.
// Built from each frame's stack, reach and angles; numbers a chart doesn't list fall back to typical road values.
const WHEEL_R = 340;   // 700c wheel with a ~32mm tyre
function bikeShape(g, bar){
  const v = (k,d) => typeof g[k]==="number" && isFinite(g[k]) ? g[k] : d;
  const hta = rad(v("htAngle",72)), sta = rad(v("stAngle",73.5));
  const stack = v("stack",560), reach = v("reach",388), drop = v("bbDrop",70);
  const ht = Math.min(Math.max(v("headTube",150),80),280), cs = v("rearCenter",420), rake = v("forkRake",45);
  const htTop = {x:reach, y:stack}, htBot = {x:reach + ht*Math.cos(hta), y:stack - ht*Math.sin(hta)};
  const toAxle = (stack - drop)/Math.sin(hta);
  const front = {x: reach + toAxle*Math.cos(hta) + rake/Math.sin(hta), y: drop};
  const rear = {x: -Math.sqrt(Math.max(cs*cs - drop*drop, 0)), y: drop};
  const stLen = Math.min(v("seatTube",0.95*stack), 0.98*stack/Math.sin(sta));
  const stTop = {x:-stLen*Math.cos(sta), y:stLen*Math.sin(sta)};
  return {front, rear, htTop, htBot, stTop, bar};
}
function drawPlot(t,b){
  const svg=$("plot");
  const cv=getComputedStyle(document.getElementById("byb")||document.documentElement);
  const c=n=>cv.getPropertyValue(n).trim();
  const cur = current();
  const yours = bikeShape(Object.assign({}, cur.geo||{}, {stack:cur.stack, reach:cur.reach, htAngle:cur.hta}), t);
  const bh = bikeShape(Object.assign(bhGeo(model,b.size), {stack:b.stack, reach:b.reach, htAngle:b.hta}), b.p);
  const all = [yours,bh];
  const minX = Math.min(...all.map(k=>k.rear.x)) - WHEEL_R - 20, maxX = Math.max(...all.map(k=>Math.max(k.front.x, k.bar.x))) + WHEEL_R + 20;
  const minY = Math.min(...all.map(k=>k.rear.y)) - WHEEL_R - 30, maxY = Math.max(...all.map(k=>Math.max(k.stTop.y, k.bar.y))) + 40;
  const W = 640, sc = W/(maxX-minX), H = Math.round((maxY-minY)*sc);
  const X=x=>((x-minX)*sc).toFixed(1), Y=y=>(H-(y-minY)*sc).toFixed(1);
  const ln=(a,b2)=>`M${X(a.x)} ${Y(a.y)}L${X(b2.x)} ${Y(b2.y)}`;
  function draw(k,col,w,dash){
    const bb={x:0,y:0}, p=k.bar;
    const frame = [ln(bb,k.stTop), ln(k.stTop,k.htTop), ln(k.htTop,k.htBot), ln(k.htBot,bb), ln(bb,k.rear), ln(k.rear,k.stTop), ln(k.htBot,k.front)].join("");
    const cockpit = ln(k.htTop,{x:p.sx,y:p.sy}) + ln({x:p.sx,y:p.sy},p);
    const da = dash ? ' stroke-dasharray="5 4"' : '';
    return `<g fill="none" stroke="${col}" stroke-width="${w}" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke">`
      + `<circle cx="${X(k.rear.x)}" cy="${Y(k.rear.y)}" r="${(WHEEL_R*sc).toFixed(1)}"${da}/><circle cx="${X(k.front.x)}" cy="${Y(k.front.y)}" r="${(WHEEL_R*sc).toFixed(1)}"${da}/>`
      + `<path d="${frame}"${da}/><path d="${cockpit}"/>`
      + `<circle cx="${X(k.rear.x)}" cy="${Y(k.rear.y)}" r="2.5" fill="${col}"/><circle cx="${X(k.front.x)}" cy="${Y(k.front.y)}" r="2.5" fill="${col}"/></g>`;
  }
  let g = `<line x1="0" x2="${W}" y1="${Y(minY+30)}" y2="${Y(minY+30)}" stroke="${c('--line')}" stroke-width="1"/>`;
  g += draw(bh, c('--accent'), 2, false);
  g += draw(yours, c('--cur'), 1.6, true);   // on top, dashed, so it shows where the two bikes overlap
  g += `<circle cx="${X(0)}" cy="${Y(0)}" r="4" fill="${c('--panel')}" stroke="${c('--ink')}" stroke-width="1.5"/>`;
  g += `<circle cx="${X(t.x)}" cy="${Y(t.y)}" r="5" fill="${c('--cur')}"/><circle cx="${X(b.p.x)}" cy="${Y(b.p.y)}" r="4" fill="${c('--accent')}" stroke="${c('--panel')}" stroke-width="1.5"/>`;
  svg.setAttribute("viewBox",`0 0 ${W} ${H}`);
  svg.innerHTML=g;
}
 
function setMode(m){
  mode=m; markDirty();
  $("modePick").setAttribute("aria-pressed",m==="pick");
  $("modeManual").setAttribute("aria-pressed",m==="manual");
  syncPicker();
  render();
}
function markDirty(){ dirty=true; }
 
$("sizeUp").onclick=()=>window.__step && window.__step(1);
$("sizeDown").onclick=()=>window.__step && window.__step(-1);
$("handlebar").onchange=()=>{ handlebar = $("handlebar").value; markDirty(); render(); };
// ---- Book Perfect Fit Consult: a pop-up asks for name and email, then shows the Calendly calendar with them filled in.
// The fit details go in the first custom question (a1) of the Calendly event, if it has one.
function fitSummary(){
  const m = window.__match; if(!m || $("rResult").hidden) return "";   // no match on screen yet: nothing to send
  const c = m.cur, b = m.b;
  return [...($("height").value ? [`Rider height: ${$("height").selectedOptions[0].text}`] : []), `Bike: ${bikeName(c)}`, `Stack ${Math.round(c.stack)} / reach ${Math.round(c.reach)}`, `Stem ${num("stem",90)}mm, ${num("spc",20)}mm spacers, ${$("ang").selectedOptions[0].text}`,
    `BlackHeart: ${BH[m.model].name} ${b.size}, ${b.stem}mm ${b.stemName} stem, ${b.spc}mm spacers (${HANDLEBARS[handlebar].label} bar)`,
    `Effective reach ${Math.round(b.p.x)} (${fmt(b.p.x-m.t.x)}), effective stack ${Math.round(b.p.y)} (${fmt(b.p.y-m.t.y)})`].join("\n");
}
if(CALENDLY_URL && /^https:\/\/(www\.)?calendly\.com\//i.test(CALENDLY_URL)){
  const dlg = $("bookDlg");
  // The button under the match always sends the rider's comparison details; the top one only if they've entered any
  let sendFit = true;
  const openBook = withFit => e=>{
    // Stop the theme's page-transition link handler from navigating away behind the pop-up
    e.preventDefault(); e.stopImmediatePropagation(); sendFit = withFit || dirty;   // the top button sends details too once the rider has used the tool
    $("bookForm").hidden = false; $("bookCal").hidden = true; $("bookCal").innerHTML = ""; $("bookErr").textContent = "";
    dlg.classList.remove("byb-dlg-wide");
    if(dlg.showModal) dlg.showModal(); else location.href = CALENDLY_URL;
    $("bkFirst").focus();
  };
  $("consultBtn").addEventListener("click", openBook(true), true);
  $("consultTop").addEventListener("click", openBook(false), true);
  $("bookClose").onclick = () => dlg.close();
  dlg.addEventListener("click", e=>{ if(e.target===dlg) dlg.close(); });   // click outside the box
  $("bookForm").addEventListener("submit", e=>{
    e.preventDefault();
    const first = $("bkFirst").value.trim(), last = $("bkLast").value.trim(), email = $("bkEmail").value.trim();
    if(!first || !last){ $("bookErr").textContent = "Please enter your first and last name."; return; }
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){ $("bookErr").textContent = "Please enter a valid email address."; return; }
    const u = new URL(CALENDLY_URL);
    u.searchParams.set("first_name", first); u.searchParams.set("last_name", last); u.searchParams.set("email", email);
    if(sendFit) u.searchParams.set("a1", fitSummary());
    u.searchParams.set("embed_domain", location.hostname); u.searchParams.set("embed_type", "Inline");
    u.searchParams.set("hide_gdpr_banner", "1");
    $("bookForm").hidden = true; $("bookCal").hidden = false; dlg.classList.add("byb-dlg-wide");
    $("bookCal").innerHTML = /YOUR-LINK/.test(CALENDLY_URL)   // preview only: no real Calendly link yet
      ? `<div class="byb-cal byb-cal-demo"><p>Zach Blume's Calendly calendar appears here, with ${esc(first)} ${esc(last)} and ${esc(email)} already filled in.</p>${sendFit ? `<pre>${esc(fitSummary())}</pre>` : ''}</div>`
      : `<iframe class="byb-cal" title="Choose a time with Zach Blume" src="${esc(u.toString())}"></iframe>`;
  });
}
$("modePick").onclick=()=>setMode("pick");
$("modeManual").onclick=()=>setMode("manual");
["stem","spc","ang"].forEach(id=>$(id).addEventListener("change",()=>{markDirty();render();}));
$("height").addEventListener("change",()=>{markDirty();render();});   // limits the recommended sizes and goes with the consult booking
 
// ---- Bike catalog: brands and models with built-in geometry
const CATALOG = {
  "Specialized":["Crux","Diverge","Diverge STR","Aethos","Tarmac SL7","Tarmac SL8","Roubaix","Allez","Allez Sprint"],
  "Trek":["Checkpoint SLR","Checkpoint SL","Checkpoint ALR","Domane SL","Domane SLR","Domane AL","Madone SLR","Émonda SL","Émonda ALR","FX"],
  "Canyon":["Grizl","Grail","Endurace","Ultimate","Aeroad","Inflite"],
  "Giant":["TCR Advanced","Defy Advanced","Revolt Advanced","Propel","Contend"],
  "Liv":["Avail","Langma","Devote"],
  "Cannondale":["SuperSix EVO","Synapse","Topstone","CAAD13","SuperX"],
  "Cervélo":["Caledonia","Caledonia-5","Áspero","R5","Soloist","S5"],
  "BMC":["Roadmachine","Teammachine","URS","Kaius"],
  "Scott":["Addict","Addict RC","Foil","Speedster"],
  "Orbea":["Orca","Terra","Avant","Gain"],
  "Pinarello":["Dogma F","Prince","Grevil"],
  "Bianchi":["Specialissima","Infinito","Arcadex","Impulso"],
  "Colnago":["V4Rs","C68","G3-X"],
  "Factor":["Ostro","O2","LS"],
  "Ridley":["Kanzo","Fenix","Helium"],
  "Felt":["Breed","FR","VR"],
  "Santa Cruz":["Stigmata"],
  "Salsa":["Warbird","Cutthroat","Journeyer","Vaya","Fargo"],
  "Surly":["Straggler","Midnight Special","Cross-Check","Disc Trucker","Long Haul Trucker","Bridge Club","Preamble","Grappler","Ghost Grappler","Ogre","ECR","Karate Monkey","Krampus","Lowside","Wednesday","Ice Cream Truck","Pugsley","Big Dummy","Corner Bar","Pack Rat","Steamroller","Troll"],
  "Kona":["Rove","Libre","Sutra"],
  "Niner":["RLT","MCR"],
  "Ibis":["Hakka MX"],
  "3T":["Exploro","Exploro Max","Exploro RaceMax","Exploro Ultra","Strada"],
  "Open":["U.P.","WI.DE.","MIN.D."],
  "Lauf":["Seigla","True Grit"],
  "Allied":["Able","Echo"],
  "Ritchey":["Outback","Road Logic"],
  "Moots":["Routt","Vamoots"],
  "Mosaic":["GT-1","RT-1"],
  "Seven":["Evergreen","Axiom"],
  "Lynskey":["GR300","R300"],
  "Argonaut":["GR3","RM3"],
  "Otso":["Waheela","Warakin"],
  "Breadwinner":["B-Road","Lolo"],
  "Rose":["Backroad","Reveal"],
  "Ribble":["Endurance SL","Gravel AL"],
  "Look":["785 Huez","765 Optimum"],
  "State":["4130 All-Road"]
};
const INLIST = {"Surly Cross-Check":"crosscheck","Specialized Crux":"crux","Specialized Aethos":"aethos","Specialized Tarmac":"tarmac","Trek Checkpoint SL/SLR":"checkpoint","Trek Domane SL/SLR":"domane","Canyon Grizl CF":"grizl","Canyon Endurace":"endurace","Giant TCR":"tcr"};
// Built-in geometry database: {brand: {model: [[from, to, note, rows], ...]}}; rows use the BHGEO column order + stock stem
const GEODB = window.BYB_GEODB || {};
const DBKEY = {};   // "Brand Model" -> versions
for(const [brand, models] of Object.entries(GEODB)){
  const list = CATALOG[brand] || (CATALOG[brand] = []);
  for(const [model, versions] of Object.entries(models)){
    if(!list.some(m=>m.toLowerCase()===model.toLowerCase())) list.push(model);
    const real = list.find(m=>m.toLowerCase()===model.toLowerCase());
    DBKEY[brand+" "+real] = versions;
  }
}
// Older list names now covered by the database under the maker's own model names
const DROP = {"Specialized":["Tarmac SL7","Tarmac SL8"],"Trek":["Checkpoint SLR","Checkpoint SL","Domane SL","Domane SLR","Domane AL","Madone SLR","Émonda SL"],
  "Canyon":["Grizl","Inflite"],"Giant":["TCR Advanced"],"Niner":["RLT","MCR"],"BMC":["Teammachine"],"Factor":["Ostro"],"Ridley":["Helium","Kanzo","Fenix"],"Otso":["Waheela"],"Liv":["Langma"],"Breadwinner":["B-Road","Lolo"],
  "Trek2":[], "Cannondale":["Synapse","Topstone"],"Colnago":["C68"],"Mosaic":["GT-1"],"Orbea":["Gain"],
  "Surly":["Disc Trucker","Long Haul Trucker","Bridge Club","Ogre","ECR","Karate Monkey","Krampus","Lowside","Wednesday","Ice Cream Truck","Pugsley","Big Dummy","Corner Bar","Steamroller","Troll"]};
DROP.Trek.push("FX");
for(const [b,ms] of Object.entries(DROP)) if(CATALOG[b]) CATALOG[b] = CATALOG[b].filter(m=>!ms.includes(m));
const ALLBIKES = Object.entries(CATALOG).flatMap(([b,ms])=>ms.map(m=>b+" "+m));
const esc = s => s.replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
// Bike model years roll over mid-season: from July on, next year's models are current
const NOW = new Date();
const CURRENT_MY = NOW.getMonth() >= 6 ? NOW.getFullYear()+1 : NOW.getFullYear();
// Snap the stock stem to the nearest dropdown choices
// ---- Year, Brand, Model, Size pickers: each choice narrows the next
const pickedName = () => $("pkBrand").value && $("pkModel").value ? $("pkBrand").value+" "+$("pkModel").value : null;
const byName = (a,b) => a.localeCompare(b,undefined,{sensitivity:"base"});
function modelsFor(brand, yr){ return (CATALOG[brand]||[]).filter(m=>builtInFor(brand+" "+m, yr)).sort(byName); }
function brandsFor(yr){ return Object.keys(CATALOG).filter(b=>modelsFor(b, yr).length).sort(byName); }
const YEAR_LIST = [];
for(let y=CURRENT_MY; y>=1990; y--) if(Object.keys(CATALOG).some(b=>modelsFor(b,y).length)) YEAR_LIST.push(String(y));
// Years older than the catalogue: Brand, Model and Size become text fields and the AI lookup finds the geometry
const OLD_YEARS = [];
for(let y=+YEAR_LIST[YEAR_LIST.length-1]-1; y>=1980; y--) OLD_YEARS.push(String(y));
// Accept the address with or without https:// (a bare host would otherwise be fetched as a path on this site)
const AI_URL = (u => u && !/^https?:\/\//i.test(u) ? "https://" + u.replace(/^\/+/, "") : u)(($("byb") && $("byb").dataset.aiUrl || "").trim());
const isFree = () => OLD_YEARS.includes($("pkYear").value);
const freeTxt = id => $(id).value.trim().replace(/\s+/g," ");
const freeKey = () => [$("pkYear").value, freeTxt("pkBrandTxt"), freeTxt("pkModelTxt"), freeTxt("pkSizeTxt")].join("|").toLowerCase();
const AI_REQUIRED = ["stack","reach"];   // found on the chart, or calculated from the full set of inputs by fillStackReach
let aiKey = "", aiBusy = false, aiState = "", aiSrc = "";   // aiState: "", "found" or "notfound" for the bike in aiKey
function fillPick(sel, opts, keep){
  sel.innerHTML = `<option value="">Select</option>` + opts.map(o=>`<option value="${esc(o)}">${esc(o)}</option>`).join("");
  sel.value = opts.includes(keep) ? keep : "";
  sel.disabled = !opts.length;
}
function syncPicker(){
  const yr = +$("pkYear").value, manual = mode==="manual", free = !manual && isFree(), txt = manual || free;
  [["pkYear","pkYearTxt",manual],["pkBrand","pkBrandTxt",txt],["pkModel","pkModelTxt",txt],["pkSize","pkSizeTxt",txt]].forEach(([s,t,on])=>{
    $(s).hidden = on; $(t).hidden = !on;
    const lab = document.querySelector(`#pickBox label[for="${s}"],#pickBox label[for="${t}"]`); if(lab) lab.htmlFor = on ? t : s;
  });
  $("aiBox").hidden = !free || !AI_URL;
  let ai = free && AI_URL && aiKey===freeKey() ? aiState : "";
  // A chart without stack and reach, and without everything needed to calculate them, is incomplete (clears once the rider types them in)
  if(ai==="found" && AI_REQUIRED.some(k=>!(typeof FREE[k]==="number" && isFinite(FREE[k])))) ai = "partial";
  $("pickHint").classList.toggle("byb-bad", ai==="notfound" || ai==="partial");
  $("pickHint").innerHTML = manual ? "Now scroll down to the <b>Full Geometry Chart</b> and type in your bike's numbers."
    : free && !AI_URL ? "For bikes this old, choose <b>Enter Numbers</b> above and then scroll down to the Full Geometry Chart."
    : ai==="found" ? "We've found your geometry through an internet search, but it should be confirmed by the BlackHeart team." + aiSrc
    : ai==="partial" ? "Unfortunately the internet search did not find a complete geometry chart. Please book a Perfect Fit Consult to discuss live with a BlackHeart rep."
    : ai==="notfound" ? "We're unable to find the geometry for your bike. If you have it, click \"Enter Numbers\" above and enter your geometry information below in the Full Geometry Comparison table."
    : free ? "Type your bike as it's written on the frame, then search."
    : "Don't see your bike? Choose <b>Enter Numbers</b> above.";
  if(free) syncAiBtn();
  else if(!manual){
    fillPick($("pkBrand"), yr ? brandsFor(yr) : [], $("pkBrand").value);
    fillPick($("pkModel"), yr && $("pkBrand").value ? modelsFor($("pkBrand").value, yr) : [], $("pkModel").value);
    const b = pickedName() && builtInFor(pickedName(), yr);
    fillPick($("pkSize"), b ? b.sizes.map(z=>z[0]) : [], $("pkSize").value);
  }
  $("lkStatus").textContent = !manual && !free && !builtInPick() && lastPick ? `Your match below is still for the ${lastPick.label}.` : "";
}
function syncAiBtn(){
  const ready = freeTxt("pkBrandTxt") && freeTxt("pkModelTxt") && freeTxt("pkSizeTxt");
  $("aiBtn").disabled = aiBusy || !ready;
  $("aiBtn").textContent = aiBusy ? "Searching…" : "Find my bike's geometry";
}
const inRange = (v,lo,hi) => typeof v==="number" && isFinite(v) && v>=lo && v<=hi;
async function aiLookup(){
  if(aiBusy || !AI_URL) return;
  const key = freeKey(), q = {year:+$("pkYear").value, brand:freeTxt("pkBrandTxt"), model:freeTxt("pkModelTxt"), size:freeTxt("pkSizeTxt")};
  aiBusy = true; syncAiBtn();
  $("aiStatus").textContent = `Searching the web for the ${q.year} ${q.brand} ${q.model} geometry. This can take up to a minute.`;
  const ctl = new AbortController(), timer = setTimeout(()=>ctl.abort(), 120000);
  let r = null;
  try{
    const res = await fetch(AI_URL, {method:"POST", headers:{"content-type":"application/json"}, body:JSON.stringify(q), signal:ctl.signal});
    r = res.ok ? await res.json() : null;
  }catch(e){ r = null; }
  clearTimeout(timer); aiBusy = false; syncAiBtn();
  if(key !== freeKey()) return;   // the rider changed the bike while we searched
  if(!r){ $("aiStatus").textContent = "The search didn't finish. Please try again."; return; }
  $("aiStatus").textContent = "";
  // Fill the chart with whatever was found; anything missing stays an empty box
  for(const k of Object.keys(FREE)) delete FREE[k];
  if(r.found) FG_KEYS.forEach(k=>{ if(typeof r[k]==="number" && isFinite(r[k])) FREE[k] = r[k]; });
  fillStackReach(FREE);
  freeVersion++;
  aiKey = key;
  // "found" as soon as the chart has any numbers; render() shows the incomplete-chart message until stack and reach are known
  aiState = r.found && Object.keys(FREE).length ? "found" : "notfound";
  aiSrc = aiState==="found" && /^https?:\/\//i.test(r.sourceUrl||"") ? ` Source: <a href="${esc(r.sourceUrl)}" target="_blank" rel="noopener nofollow">${esc(String(r.sourceName||"geometry chart").slice(0,80))}</a>.` : "";
  markDirty(); syncPicker(); render();
}
fillPick($("pkYear"), [...YEAR_LIST, ...OLD_YEARS], "");
["pkYear","pkBrand","pkModel","pkSize"].forEach(id=>$(id).addEventListener("change",()=>{
  syncPicker();
  if(builtInPick()) markDirty();
  render();
}));
["pkYearTxt","pkBrandTxt","pkModelTxt","pkSizeTxt"].forEach(id=>{
  $(id).addEventListener("input",()=>{ syncAiBtn(); if(freeKey()!==aiKey) $("aiStatus").textContent=""; syncPicker(); render(); });
  $(id).addEventListener("keydown",e=>{ if(e.key==="Enter" && mode==="pick" && !$("aiBtn").disabled){ e.preventDefault(); aiLookup(); } });
});
$("aiBtn").addEventListener("click", aiLookup);
syncPicker();   // every field starts on "Select"
 
// ---- Email gate: the bike fields unlock once the rider gives an email (remembered on this browser)
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const GATE_KEY = "pfai-email";
const GATE_TTL = 24*3600*1000;   // ask for the email again after 24 hours
function unlockGate(email){
  $("bikeFields").disabled = false;
  $("gate").hidden = true;
  if($("bkEmail") && !$("bkEmail").value) $("bkEmail").value = email;
  syncPicker();
}
$("bybGateForm").addEventListener("submit", e=>{
  e.preventDefault();
  const email = $("gateEmail").value.trim();
  if(!EMAIL_RE.test(email)){ $("gateErr").textContent = "Please enter a valid email address."; $("gateEmail").focus(); return; }
  $("gateErr").textContent = "";
  // Sign up through the theme's customer form in the background; the tool unlocks whatever the response
  const f = e.target, action = f.getAttribute("action") || "";
  if(/\/contact/.test(action)) fetch(action, {method:"POST", body:new FormData(f), credentials:"same-origin", keepalive:true}).catch(()=>{});
  // Tell the BlackHeart team through the lookup service (it sends at most one notice per email per day)
  if(AI_URL){ try{ fetch(new URL("/notify", AI_URL), {method:"POST", headers:{"content-type":"application/json"}, body:JSON.stringify({email}), keepalive:true}).catch(()=>{}); }catch(_){} }
  try{ localStorage.setItem(GATE_KEY, JSON.stringify({email, t:Date.now()})); }catch(_){}
  unlockGate(email);
  $("modePick").focus();
});
try{
  const raw = localStorage.getItem(GATE_KEY);
  let saved = null; try{ saved = JSON.parse(raw); }catch(_){}
  if(saved && EMAIL_RE.test(saved.email || "") && Date.now() - saved.t < GATE_TTL) unlockGate(saved.email);
  else if(raw){ const old = (saved && saved.email) || raw; if(EMAIL_RE.test(old)) $("gateEmail").value = old; }   // expired: prefill, rider just clicks Let's go
}catch(_){}
 
 
new MutationObserver(render).observe(document.documentElement,{attributes:true,attributeFilter:["data-theme"]});
render();
})();